import React from 'react';
import { Printer, Mail, Phone, MapPin, Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 pt-16 pb-8" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-16">
          {/* Brand */}
          <div data-id="element-17">
            <div className="flex items-center space-x-2 mb-6" data-id="element-18">
              <div className="p-1.5 rounded bg-white text-blue-900" data-id="element-19">
                <Printer className="h-5 w-5" data-id="element-20" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-21">
                LIBERTY<span className="font-light" data-id="element-22">SCREEN</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-6 text-gray-400" data-id="element-23">
              Premium screen printing services for brands that demand quality.
              We bring your designs to life with precision and care.
            </p>
            <div className="flex space-x-4" data-id="element-24">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-25">
                <Instagram className="h-5 w-5" data-id="element-26" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-27">
                <Facebook className="h-5 w-5" data-id="element-28" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-29">
                <Twitter className="h-5 w-5" data-id="element-30" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-31">
            <h4 className="text-white font-bold mb-6" data-id="element-32">Quick Links</h4>
            <ul className="space-y-3 text-sm" data-id="element-33">
              <li data-id="element-34">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-35">
                  Services
                </a>
              </li>
              <li data-id="element-36">
                <a href="#portfolio" className="hover:text-white transition-colors" data-id="element-37">
                  Portfolio
                </a>
              </li>
              <li data-id="element-38">
                <a href="#process" className="hover:text-white transition-colors" data-id="element-39">
                  Our Process
                </a>
              </li>
              <li data-id="element-40">
                <a href="#testimonials" className="hover:text-white transition-colors" data-id="element-41">
                  Testimonials
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-white transition-colors" data-id="element-43">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-44">
            <h4 className="text-white font-bold mb-6" data-id="element-45">Services</h4>
            <ul className="space-y-3 text-sm" data-id="element-46">
              <li data-id="element-47">
                <a href="#" className="hover:text-white transition-colors" data-id="element-48">
                  Custom T-Shirts
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-white transition-colors" data-id="element-50">
                  Hoodies & Sweatshirts
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-white transition-colors" data-id="element-52">
                  Corporate Uniforms
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-white transition-colors" data-id="element-54">
                  Embroidery
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-white transition-colors" data-id="element-56">
                  Promotional Products
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-57">
            <h4 className="text-white font-bold mb-6" data-id="element-58">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-59">
              <li className="flex items-start" data-id="element-60">
                <MapPin className="h-5 w-5 mr-3 text-red-500 flex-shrink-0" data-id="element-61" />
                <span data-id="element-62">
                  123 Print Street, Suite 100
                  <br data-id="element-63" />
                  Creative District, NY 10012
                </span>
              </li>
              <li className="flex items-center" data-id="element-64">
                <Phone className="h-5 w-5 mr-3 text-red-500 flex-shrink-0" data-id="element-65" />
                <span data-id="element-66">(555) 123-4567</span>
              </li>
              <li className="flex items-center" data-id="element-67">
                <Mail className="h-5 w-5 mr-3 text-red-500 flex-shrink-0" data-id="element-68" />
                <span data-id="element-69">hello@libertyscreen.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-70">
          <p data-id="element-71">&copy; 2024 Liberty Screen Printing. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-72">
            <a href="#" className="hover:text-white transition-colors" data-id="element-73">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-74">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}